import { Box, Divider, Stack } from '@mui/material';
import { editor } from 'monaco-editor';
import Controller from '../../../Components/Drawers/Controller/Controller';
import ControllerZeroHeading from '../../../Components/Drawers/Controller/ControllerZeroHeading';
import { ActionMappingControlList } from '../../Drawers/Controller/ActionMappingControlList';

interface ControllerConfigurationTabProps {
  editor?: editor.IStandaloneCodeEditor;
}

const ControllerConfigurationTab: React.FC<ControllerConfigurationTabProps> = ({ editor }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="column" spacing={2}>
        <Box
          width="100%"
          alignSelf="center"
          textAlign="center"
          sx={{
            // Make the controller SVG responsive up to 300px, then fixed
            '& svg': { width: '100%', maxWidth: 300, height: 'auto' },
          }}
        >
          <Controller editor={editor} />
        </Box>
        <ControllerZeroHeading />
        <Divider />
        <ActionMappingControlList device="controller" editor={editor} />
      </Stack>
    </Box>
  );
};

export default ControllerConfigurationTab;
